var exports = {
  "mB": "LocalNavigation__QHRW7C",
  "Dn": "PopoverTab__CFa0O_",
  "oK": "PopoverLink__ubQB81",
};

module.exports = exports;
